<template>
<!-- 群艺师资详情 -->
    <div class="teacher_detail_warp">
        <BaseDetail :showCom="false" ref="baseDetail">
            <template slot="cont" scope="{info}">
                <div  class="cont_warp">
                    <div class="cont_top">
                        <el-image class="user_img" :src="info.imageUrl">
                            <div slot="placeholder" style="text-align:center;margin-top:50px;">
                                <i class="el-icon-loading"></i>
                            </div>
                        </el-image>
                        <div class="cont_top_r">
                            <div class="user_name">{{info.realName}}</div>
                            <div class="user_tags">
                                <Tag effect="plain" type="info" size="medium">{{info.major}}</Tag>
                            </div>
                        </div>
                    </div>
                    <div class="teacher_content">
                        长期从事非物质文化的收集整理工作，组织调查了我州境内387个非遗项目，申报了一批国家、省、州级非遗产项目和传承人，2008年撰写施万恒、后宝云、阿家文、普美芳三位民间艺人材料，成功申报为第一批国家级非物质文化遗产项目代表性传承人。 
                    </div>
                </div>
            </template>
            <div class="recommend_teacher" slot="recom" v-if="false">
                <div class="title">老师推荐</div>
                <div class="teacher_list">
                    <div class="teacher_list_item">
                        <img class="teacher_img" src="https://www.ynggwhy.cn/file/hbY3dGDs5jDBxn6RTX/2020-08-01/source/8f8b82d0fc6c47f4945af56b3bbdd2a9.jpeg">
                        <div class="tags_box">
                            <div class="user_name">腊国庆</div>
                            <div class="user_tags">
                                <Tag effect="plain" type="info" size="medium">音乐</Tag>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </BaseDetail>
    </div>
</template>

<script>
import BaseDetail from '@c/BaseDetail'
import { Tag } from 'element-ui';
export default {
    name: 'teacherDetail',
    components: {
        BaseDetail,
        Tag
    },
    data() {
        return {

        }
    },
    methods: {

    },
    mounted() {
        this.$refs.baseDetail.videoLoad('artist')
    }
}
</script>

<style scoped lang="scss">
.teacher_detail_warp {
    background: #f8f8f8;
    min-height: calc(100vh - 315px);
    .cont_warp {
        padding: 0 30px 30px;
        border-radius: 5px;
        .cont_top {
            width: 100%;
            height: 214px;
            border-bottom: 1px solid #e5e5e5;
            display: flex;
            align-items: center;
            line-height: 1;
        }
        .user_img {
            width: 129px;
            height: 129px;
            border-radius: 50%;
        }
        .cont_top_r {
            padding-left: 40px;
        }
        .user_name {
            font-size: 24px;
            color: #000;
        }
        .user_tags {
            padding-top: 20px;
            font-size: 13px;
            color: #999;
        }
        .teacher_content {
            width: 100%;
            padding-top: 45px;
        }
    }
    .recommend_teacher {
        margin-top: 20px;
        box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.05);
        border-radius: 5px;
        background: #fff;
        line-height: 1;
        .title {
            padding: 28px 0 28px 24px;
            font-size: 24px;
            font-weight: 800;
        }
        .teacher_list_item {
            display: flex;
            align-items: center;
            cursor: pointer;
            padding: 36px 0 44px 18px;
            border-bottom: 1px solid #e5e5e5;
            .teacher_img {
                width: 70px;
                height: 70px;
                border-radius: 50%;
            }
            .tags_box {
                padding-left: 24px;
                
            }
            .user_name {
                font-size: 22px;
                color: #000;
            }
            .user_tags {
                padding-top: 18px;
                font-size: 13px;
                color: #999;
            }
        }
    }
}
</style>